import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Widget as WidgetContainer, WidgetSection } from '@factorialco/f0-react/dist/experimental'
import { Clock, Crown, Target } from '@factorialco/f0-react/icons/app'

import { i18nDateToString } from 'modules/core/lib/dates'
import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import ExtraHoursUtils from 'modules/attendance/lib/utils/ExtraHoursUtils'

const ExtraHoursCounter = () => {
  const { balances, extraHoursMinutes, currentEmployeesSetting } = useTimesheetData()

  const getExtraHoursDescription = () => {
    const isCalculatingExtraHours = ExtraHoursUtils.isCalculatingExtraHours(balances)

    if (isCalculatingExtraHours) {
      const extraHoursCalculationOn = ExtraHoursUtils.extraHoursCalculationOn(balances)
      const extraHoursCalculationOnDateString = i18nDateToString(
        extraHoursCalculationOn,
        'ui_dmy_long'
      )

      return {
        title: i18n.t('clock_in.extra_hours_widget.calculation_in_progress', {
          endDate: extraHoursCalculationOnDateString,
        }),
        icon: Clock,
        isCalculating: true,
        extraHours: 0,
      }
    }

    if (extraHoursMinutes === 0) {
      return {
        title: i18n.t('clock_in.extra_hours_widget.on_track'),
        icon: Target,
        isCalculating: false,
        extraHours: extraHoursMinutes,
      }
    }

    return {
      title:
        currentEmployeesSetting?.extraHoursBaseline === 'contract_hours'
          ? i18n.t('clock_in.extra_hours_widget.extra_hours_accumulated_contract')
          : i18n.t('clock_in.extra_hours_widget.extra_hours_accumulated_planned'),
      icon: Crown,
      isCalculating: false,
      extraHours: extraHoursMinutes,
    }
  }

  const { title, icon, isCalculating, extraHours } = getExtraHoursDescription()

  return (
    <WidgetContainer
      header={{
        title: i18n.t('clock_in.extra_hours_widget.title'),
      }}
    >
      <WidgetSection title={title}>
        <Box inline flexDirection="row" gap="s8" alignItems="center">
          <F0Icon icon={icon} size="lg" color="primary" />
          <Box className="text-2xl text-f1-foreground font-semibold cursor-default">
            {isCalculating ? '-' : minutesToText(extraHours, false, true)}
          </Box>
        </Box>
      </WidgetSection>
    </WidgetContainer>
  )
}

export default ExtraHoursCounter
